import React from 'react';
import { Element as ReactScrollElement } from 'react-scroll';
import Tab from './tab';

const tabs = (props) => {

    const {tabIndex, product} = props;
    const children = React.Children.map(
      props.children,
      (child, index) => {
        if(child.type === Tab) {
          return React.cloneElement(child, {
            active: tabIndex === index,
            product: product,
            prefetch: child && child.props.prefetch
          });
        }
        else {
          return child;
        }
      }
    );


    return (
      <ReactScrollElement name='pdpTabs' className='pdp-tab-content'>
      {children}
      </ReactScrollElement>
    );

}

export default tabs;
